import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  isFullSiteMode,
  isMobileDevice,
  setResponsiveMode,
  setFullSiteMeta,
  setMobileMeta,
} from 'utils/fullSite';
import { signInFullSite as signInFullSiteClevertap } from 'clevertap/mWebFullSiteSwitch';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import { MOKA_OPEN_API_HOST } from '../../../api/constants';
import { replaceView } from '../../../state/openPlatform/actions';
import { loginRequest } from '../../../state/action-mess';
import AuthTitle from '../../Titles/AuthTitle';
import LoginForm from './LoginForm';
import styles from './style.css';

function MokaOpenApiRedirect(props) {
  const { currentlySending, isMokaOpenApiRedirect, onSubmit, app } = props;

  return (
    <div className={styles.root} id="login-page">
      <div
        className="mt-40px mb-40px"
        style={{ textAlign: 'center', wordWrap: 'break-word' }}
      >
        <Trans>
          Sign in to use your Moka account with <b>{app.name}</b>
        </Trans>
      </div>
      <LoginForm
        onSubmit={onSubmit}
        currentlySending={currentlySending}
        isMokaOpenApiRedirect={isMokaOpenApiRedirect}
      />
      <hr className="mt-30px mb-30px" />
      <div className="mt-20px mb-20px" style={{ textAlign: 'center' }}>
        <Trans>
          Don't have an account? <Link to="/register">Sign up here</Link>
        </Trans>
      </div>
    </div>
  );
}

class Login extends React.Component {
  componentWillMount() {
    const { query } = this.props.location;
    if (query.next && query.next.startsWith(MOKA_OPEN_API_HOST)) {
      this.props.dispatch(replaceView({ next: query.next }));
    }
  }

  render() {
    const { currentlySending, isMokaOpenApiRedirect, app } = this.props;
    const isMobileMode = isMobileDevice() && !isFullSiteMode();

    if (isMokaOpenApiRedirect) {
      return (
        <MokaOpenApiRedirect
          currentlySending={currentlySending}
          isMokaOpenApiRedirect={isMokaOpenApiRedirect}
          onSubmit={this.handleSubmit}
          app={app}
        />
      );
    }

    return (
      <div className={styles.root} id="login-page">
        <I18n>{({ i18n }) => <AuthTitle title={i18n._(t`Sign in`)} />}</I18n>
        <LoginForm
          onSubmit={this.handleSubmit}
          currentlySending={currentlySending}
          isMokaOpenApiRedirect={isMokaOpenApiRedirect}
        />

        <hr className="mt-30px mb-30px" />

        <div className="mt-20px mb-20px" style={{ textAlign: 'center' }}>
          <Trans>
            Don’t have a Moka account? <Link to="/register">Sign up</Link>
          </Trans>
        </div>

        <br />

        {isMobileMode && (
          <div id="full-site-link">
            <div className={styles['full-site']}>
              <div className={`col-sm-5 ${styles['line-separator']}`} />
              <div className={`col-sm-2 ${styles['text-or']}`}>or</div>
              <div className={`col-sm-5 ${styles['line-separator']}`} />
            </div>
            <div
              className={styles['full-site-link']}
              onClick={this._onClickFullSite}
            >
              <Trans>Sign In Full Site</Trans>
            </div>
          </div>
        )}
      </div>
    );
  }

  /**
   * Handle submission of login form
   * @param values the JSON containing {email,password}
   */
  handleSubmit = values => {
    const {
      location,
      dispatch,
      businessTypesState,
      businessCategoriesAllState,
    } = this.props;
    const { email, password } = values;
    let trimEmail = email.trim();
    if (!isNaN(email)) {
      if (trimEmail[0] === '0') {
        trimEmail = trimEmail.slice(1);
      } else if (trimEmail[0] === '+') {
        trimEmail = trimEmail.slice(3);
      }
    }
    const nextURL = location.query.next;
    const payload = isNaN(trimEmail)
      ? { email: trimEmail, password }
      : { phone: `+62${trimEmail}`, password };
    dispatch(
      loginRequest(
        { ...payload, businessTypesState, businessCategoriesAllState },
        nextURL
      )
    );
  };

  _onClickFullSite = () => {
    // TODO use redux state instead of jquery
    // hide full site hyperlink
    $('#full-site-link').hide();

    if (!isFullSiteMode()) {
      setResponsiveMode(false);
    } else {
      setResponsiveMode(true);
    }

    // disable responsive
    if (isMobileDevice()) {
      setFullSiteMeta();
    } else {
      // enable responsive
      setMobileMeta();
    }

    signInFullSiteClevertap();
  };
}

function mapStateToProps(state) {
  const {
    currentlySending,
    businessTypesState,
    businessCategoriesAllState,
  } = state.moka;
  const { isMokaOpenApiRedirect, app } = state.openPlatform.login;

  return {
    currentlySending,
    isMokaOpenApiRedirect,
    app,
    businessTypesState,
    businessCategoriesAllState,
  };
}

export default connect(mapStateToProps)(Login);
